import React, { useEffect, useState, useRef } from "react";
import "./updateContent.style.scss";
import { post, get, responseValidator } from "../../../../api";
import { toast } from "react-toastify";
import Loading from "../../../../loading/loading.index";
import { Button, Card, Typography } from "antd";
import { Editor } from "@tinymce/tinymce-react";

export default function UserDetail() {
    const [id, setId] = useState(null);
    const [text, setText] = useState();
    const [submitloading, setSubmitLoading] = useState(false);
    const [initText, setInitText] = useState();

    // const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null);
    useEffect(() => {
        setId(window.location.pathname.split("/")[4]);
        console.log("update content request done");
        get("/Content/" + window.location.pathname.split("/")[4]).then(res => {
            if (responseValidator(res.status)) {
                setInitText(res.data.data.text);

                setData(res.data.data);
            } else if (res.data.message) toast.error(res.data.message);
        });
    }, []);

    const editorRef = useRef(null);
    const log = () => {
        if (editorRef.current) {
            console.log(editorRef.current.getContent());
        }
    };

    if (!data) return <Loading />;

    function submitHandler() {
        setSubmitLoading(true);
        const body = {
            id: id,
            text
        };

        post("/Content/Update", body).then(res => {
            setSubmitLoading(false);
            if (responseValidator(res.status)) {
                toast.success(res.data.message);
                setTimeout(
                    () => window.location.replace("/adminpanel/content"),
                    2000
                );
            } else toast.error(res.data.message);
        });
    }

    return (
        <div className="temx-user-detail-page">
            <Card
                title={
                    <div
                        style={{ display: "flex", alignItem: "center" }}
                        className="card-title"
                    >
                        <p>ویرایش محتوا {data.title}</p>
                        <span style={{ flex: "1" }} />
                        <Button
                            onClick={() =>
                                window.location.replace("/adminpanel/content")
                            }
                            type="link"
                        >
                            بازگشت به لیست
                        </Button>
                    </div>
                }
            >
                <Editor
                    apiKey="kbejtjil91dnjqm8a0fcd4aqyhm6feugw0mtlog40wvmhc03"
                    onInit={(evt, editor) => (editorRef.current = editor)}
                    initialValue={initText}
                    value={text}
                    onEditorChange={newText => setText(newText)}
                    init={{
                        height: 500,
                        menubar: false,
                        content_langs: { title: "Persian", code: "fa" },
                        language: "fa",
                        plugins: [
                            "advlist autolink lists link image charmap print preview anchor",
                            "searchreplace visualblocks code fullscreen",
                            "insertdatetime media table paste code help wordcount"
                        ],
                        toolbar:
                            "undo redo | formatselect | " +
                            "bold italic backcolor | alignleft aligncenter " +
                            "alignright alignjustify | bullist numlist outdent indent | " +
                            "removeformat | help",
                        content_style:
                            "body { font-family:system-ui ,Arial,sans-serif; font-size:14px }"
                    }}
                />
                <br />
                <Button
                    className="my-real-btn"
                    disabled={false}
                    onClick={submitHandler}
                    type={"primary"}
                    loading={submitloading}
                >
                    ویرایش
                </Button>
            </Card>
        </div>
    );
}
